import { createContext } from "react";

export const TabContext = createContext<Record<string, any>>({});
